(() => {
  const sections = document.querySelectorAll(".ec-faq-session");

  if (!sections.length) return;

  sections.forEach((section) => {
    const modalId = section.getAttribute("data-modal-id");
    if (!modalId) return;

    const modal = document.getElementById(modalId);
    if (!modal) return;

    const modalBodyContent = modal.querySelector(
      ".ec-faq-session__modal-body-content",
    );
    const modalIndex = modal.querySelector(".ec-faq-session__modal-index");
    const modalQuestion = modal.querySelector(".ec-faq-session__modal-question");
    const closeButtons = modal.querySelectorAll("[data-ec-faq-close-modal]");

    function openModal(cardEl, contentEl) {
      if (!modalBodyContent || !contentEl) return;

      modalBodyContent.innerHTML = contentEl.innerHTML;

      if (modalIndex && cardEl) {
        const index = cardEl.getAttribute("data-ec-faq-index");
        modalIndex.textContent = index || "";
      }

      if (modalQuestion) {
        const cardTitle =
          cardEl && cardEl.querySelector(".ec-faq-session__card-title");

        modalQuestion.textContent = cardTitle
          ? cardTitle.textContent.trim()
          : "";
      }

      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("ec-faq-session__modal--open");
      document.body.style.overflow = "hidden";
    }

    function closeModal() {
      if (!modalBodyContent) return;

      modal.classList.remove("ec-faq-session__modal--open");
      modal.setAttribute("aria-hidden", "true");
      modalBodyContent.innerHTML = "";

      if (modalIndex) modalIndex.textContent = "";
      if (modalQuestion) modalQuestion.textContent = "";

      document.body.style.overflow = "";
    }

    section.querySelectorAll("[data-ec-faq-open-modal]").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const card = btn.closest(".ec-faq-session__card");
        const body = btn.closest(".ec-faq-session__card-body");
        const inner =
          body && body.querySelector(".ec-faq-session__card-body-inner");

        if (inner) openModal(card, inner);
      });
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeModal();
    });

    function checkTruncation() {
      section
        .querySelectorAll(".ec-faq-session__card-body-inner")
        .forEach((inner) => {
          const body = inner.closest(".ec-faq-session__card-body");
          const moreBtn =
            body && body.querySelector("[data-ec-faq-open-modal]");

          if (!moreBtn) return;

          if (inner.scrollHeight > inner.clientHeight) {
            moreBtn.classList.add("ec-faq-session__card-body-more--visible");
          } else {
            moreBtn.classList.remove("ec-faq-session__card-body-more--visible");
          }
        });
    }

    checkTruncation();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(checkTruncation);

      section
        .querySelectorAll(".ec-faq-session__card-body-inner")
        .forEach((element) => observer.observe(element));
    }
  });
})();
